<template lang="pug">
  #MsgManagerIndex.container-width
    h5.text-center.pt-2 訊息管理
    .px-3
      b-card.border-0.mb-2.customerCard.word-break-all(
        bg-variant="light",
        v-for="(user,index) in users",
        :key="user.id",
        @click="openMsgHandler(user)"
      )
        .row.no-gutters
          .col-10.pr-1
            .row.align-items-center.no-gutters
              .col-4.pr-2
                ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                  :profileUrl="user.img",
                  :style="{ 'width': '60px', 'height': '60px' }"
                )
              .col-8.pl-2
                p.mb-0.font-weight-bold 暱稱名 {{ user.name }}
                p.mb-0 備註名 {{ user.nick_name }}
                small.mb-0.text-gray.d-block.w-100 {{ user.last_msg }}
          .col-2.pl-1.d-flex.flex-column.justify-content-between.align-items-end
            b-badge.px-2.py-1(
              variant="primary",
              v-if="user.is_read === false"
            ) NEW
            small.mb-0.d-block.w-100.text-right(
              v-if="user.is_read === true"
            ) 已讀
            small.mb-0.d-block.w-100.text-right {{ user.updated_at }}

</template>

<script>
import { SM_CHAT_ROOM_INDEX } from '@/router/sm/chat-room';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

// 測試圖片
import userExOneUrl from '@/assets/images/example/sa_1.png';
import userExTwoUrl from '@/assets/images/example/sa_2.png';

export default {
  name: 'MsgManagerIndex',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      users: [
        {
          id: 0,
          name: 'Patty',
          nick_name: '小白兔',
          img: userExOneUrl,
          last_msg: '您好請問能協助我嗎',
          updated_at: '07/01',
          is_read: false
        },
        {
          id: 1,
          name: 'LuLu',
          nick_name: '超想白大戶',
          img: userExTwoUrl,
          last_msg: '我想詢問美白產品',
          updated_at: '06/28',
          is_read: true
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('toggleLoading', false);
  },
  methods: {
    openMsgHandler(user) {
      const vm = this;
      console.log(user);
      vm.$swal.fire({
        title: '載入對話中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });
      setTimeout(() => {
        vm.$swal.close();
        vm.$router.push({
          name: SM_CHAT_ROOM_INDEX
        });
      }, 2000);
    }
  }
};
</script>

<style>

</style>
